// @flow
import types from './stockConstants';
import productTypes from '../../catalog-management/product/productConstants';

const INIT_STATE = {
    variantList: [],
    variant: {},
    variantNotFound: false,
    variantPrint: {},
    suppliers:[],
    chartData: {},
    reservations: null,
    reservationsLoading: false,
    aluminiumStock: {},
    loading: false,
    success: null,
    error: null
};

const Stock = (state = INIT_STATE, action) => {
    switch (action.type) {
        case types.CLEAR_STATE:
            return {
                ...INIT_STATE
            }
        //List
        case types.GET_VARIANTS:
            return {
                ...state,
                loading: true
            };
        case types.GET_VARIANTS_SUCCESS:

            return {
                ...state,
                variantList: action.payload.data,
                loading: false,
                error: null
            };
        case types.GET_VARIANTS_FAILED:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        //List

        //List
        case types.GET_STOCKS:
            return {
                ...state,
                variantNotFound: false,
                loading: true
            };
        case types.GET_STOCKS_SUCCESS:
            return {
                ...state,
                variant: action.payload.data,
                variantNotFound: false,
                loading: false,
                error: null
            };
        case types.GET_STOCKS_FAILED:
            return {
                ...state,
                variant: {},
                variantNotFound: true,
                error: action.payload,
                loading: false
            };
        //List
        //Chart data
        case types.GET_STOCKS_CHARTS:
            return {
                ...state,
                chartData: action.payload.data,
            };
        //Chart data
        //Reservations (ADR-0025): loaded on demand, with its own flag so the
        //popup shows a spinner without the page-wide loader taking over.
        case types.GET_RESERVATIONS:
            return {
                ...state,
                reservationsLoading: true,
            };
        case types.GET_RESERVATIONS_SUCCESS:
            return {
                ...state,
                reservations: action.payload.data,
                reservationsLoading: false,
            };
        case types.GET_RESERVATIONS_FAILED:
            return {
                ...state,
                reservations: null,
                reservationsLoading: false,
                error: action.payload,
            };
        //Reservations
        //create stock
        case types.POST_STOCKS:
            return {
                ...state,
                success: null,
                loading: true
            };
        case types.POST_STOCKS_SUCCESS:
            let updatedList = state.variantList;
            if (action.variantId && action.quantity) {
                updatedList = state.variantList.map(item => {
                    if (item.id === action.variantId) {
                        return {
                            ...item,
                            stockQuantity: (item.stockQuantity || 0) + Number(action.quantity),
                            availableStockQuantity: (item.availableStockQuantity || 0) + Number(action.quantity)
                        };
                    }
                    return item;
                });
            }

            // The detail page holds the same variant: move its counters too so
            // the header reads right before the ledger is refetched.
            let updatedVariant = state.variant;
            if (action.variantId && action.quantity && state.variant && state.variant.id === action.variantId) {
                updatedVariant = {
                    ...state.variant,
                    stockQuantity: (state.variant.stockQuantity || 0) + Number(action.quantity),
                    availableStockQuantity: (state.variant.availableStockQuantity || 0) + Number(action.quantity)
                };
            }

            return {
                ...state,
                variantList: updatedList,
                variant: updatedVariant,
                success: 'STOCK.CREATED.SUCESS',
                loading: false,
                error: null
            };
        case types.POST_STOCKS_FAILED:
            return {
                ...state,
                success: null,
                error: action.payload,
                loading: false
            };
        //create stock

        //update variant threshold
        case productTypes.PATCH_VARIANT_SUCCESS:
            let updatedListVariant = state.variantList;
            if (action.variantId && action.variant) {
                updatedListVariant = state.variantList.map(item => {
                    if (item.id === action.variantId) {
                        return {
                            ...item,
                            ...action.variant
                        };
                    }
                    return item;
                });
            }
            let patchedVariant = state.variant;
            if (action.variantId && action.variant && state.variant && state.variant.id === action.variantId) {
                patchedVariant = { ...state.variant, ...action.variant };
            }
            return {
                ...state,
                variantList: updatedListVariant,
                variant: patchedVariant
            };
        //update variant threshold
        //get variant
        case types.GET_VARIANT:
            return {
                ...state,
                loading: true
            };
        case types.GET_VARIANT_SUCCESS:
            return {
                ...state,
                variantPrint: action.payload.data,
                loading: false,
                error: null
            };
        case types.GET_VARIANT_FAILED:
            return {
                ...state,
                variantPrint: {},
                error: action.payload,
                loading: false
            };
        case types.GET_SUPPLIERS:
            return {
                ...state,
                suppliers: action.payload.data.items,
                error: null,
                loading: false
            };
        //get variant

        case types.GET_ALUMINIUM_STOCK:
            return {
                ...state,
                loading: true
            };
        case types.GET_ALUMINIUM_STOCK_SUCCESS:
            return {
                ...state,
                aluminiumStock: action.payload.data,
                error: null,
                loading: false
            };
        case types.GET_ALUMINIUM_STOCK_FAILED:
            return {
                ...state,
                aluminiumStock: {},
                error: action.payload,
                loading: false
            };

        default:
            return state;
    }
};

export default Stock;
